export const PAYMENT_TYPE = {
  CASH: 1,
  CHECK: 2,
};

const _PAYMENT_TYPE_DESCRIPTION_MAP = {};
_PAYMENT_TYPE_DESCRIPTION_MAP[PAYMENT_TYPE.CASH] = 'Cash';
_PAYMENT_TYPE_DESCRIPTION_MAP[PAYMENT_TYPE.CHECK] = 'Check';

export const PAYMENT_TYPE_DESCRIPTION_MAP = _PAYMENT_TYPE_DESCRIPTION_MAP;

export default {
  PAYMENT_TYPE,
  PAYMENT_TYPE_DESCRIPTION_MAP,
};
